import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { InstrumentType, Quote } from '@zero/shared/util-models';
import { CallMoneyAlternatives } from '../entities/call-money-alternatives.entity';
import { EtfsByIndices } from '../entities/etfs-by-indices.entity';
import { MostActiveAssets } from '../entities/most-active-assets.entity';
import { MostPopular } from '../entities/most-popular.entity';
import { WinnerLoser } from '../entities/winner-loser.entity';

export const assetClassOverviewActions = createActionGroup({
  source: 'AssetClassOverview',
  events: {
    'Load Etfs By Indices': emptyProps(),
    'Load Most Popular Etfs': emptyProps(),
    'Update Most Popular Etfs Quotes': props<{ quotes: Record<string, Quote> }>(),
    'Load Most Popular Stocks': emptyProps(),
    'Update Most Popular Stocks Quotes': props<{ quotes: Record<string, Quote> }>(),
    'Load Call Money Alternatives': emptyProps(),
    'Load Most Active Assets': props<{ instrumentType: InstrumentType }>(),
    'Update Most Active Assets Quotes': props<{ quotes: Record<string, Quote> }>(),
    'Load Winner Loser': props<{ instrumentType: InstrumentType }>(),
    'Update Winner Loser Quotes': props<{ quotes: Record<string, Quote> }>(),
  },
});

export const assetClassOverviewApiActions = createActionGroup({
  source: 'AssetClassOverview API',
  events: {
    'Load Etfs By Indices Success': props<{ response: EtfsByIndices[] }>(),
    'Load Etfs By Indices Failure': props<{ error: HttpErrorResponse }>(),
    'Load Most Popular Etfs Success': props<{ response: MostPopular }>(),
    'Load Most Popular Etfs Failure': props<{ error: HttpErrorResponse }>(),
    'Load Most Popular Stocks Success': props<{ response: MostPopular }>(),
    'Load Most Popular Stocks Failure': props<{ error: HttpErrorResponse }>(),
    'Load Call Money Alternatives Success': props<{ response: CallMoneyAlternatives[] }>(),
    'Load Call Money Alternatives Failure': props<{ error: HttpErrorResponse }>(),
    'Load Most Active Assets Success': props<{ response: MostActiveAssets }>(),
    'Load Most Active Assets Failure': props<{ error: HttpErrorResponse }>(),
    'Load Winner Loser Success': props<{ response: WinnerLoser }>(),
    'Load Winner Loser Failure': props<{ error: HttpErrorResponse }>(),
  },
});
